var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CONFIG from './config/index';
var API = __assign({}, CONFIG);
// 记录所有别名，别名是不推荐使用的方法名！
var ALIAS = [];
// 将方法配置格式化
Object.keys(CONFIG).forEach(function (item) {
    var alias = CONFIG[item].alias;
    API[item] = CONFIG[item];
    if (alias) {
        alias = alias.split('|');
        alias.forEach(function (als) {
            if (als) {
                ALIAS.push(als);
                // name属性值即为调用bridge时传递给native的方法名
                !CONFIG[item]['name'] && (CONFIG[item]['name'] = item);
                API[als] = CONFIG[item];
            }
        });
    }
});
export { API, ALIAS };
